import $clamp from 'clamp-js';

$(document).on('turbolinks:load', function() {
  $('.js-clamp-2-lines').each(function() {
    $clamp(this, { clamp: 2 });
  });
});
